const mockSwitch = false;
const isProduction = process.env.NODE_ENV === 'production';
let API_HOST: string;

if (isProduction) {
  // 生产环境：使用相对路径，通过 nginx 转发到后端服务
  API_HOST = '/api';
} else {
  // 开发环境：根据 mockSwitch 决定是否使用 mock 数据
  if (mockSwitch) {
    // 使用 mock 数据，不添加 /api 前缀
    API_HOST = '';
  } else {
    // 使用真实 API，通过代理转发到后端服务
    API_HOST = '/devApi';
  }
}

// 构建完整的 API 路径
export const buildApiPath = (path: string): string => {
  // 确保 path 以 / 开头
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_HOST}${normalizedPath}`;
};

export const FRONTEND_VERSION = '1.1.12.12';

// 默认重置密码
export const DEFAULT_RESET_PASSWORD = '123456';

// 台账直连阶段（含咕咕任务中间态与终态）
export const LedgerDispatchPlatformStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  INIT: 'init',
  SAVE_AND_BIND: 'save-and-bind',
  FLOW_ONCE: 'flow-once',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
} as const;

export type LedgerDispatchPlatformStatusValue =
  (typeof LedgerDispatchPlatformStatus)[keyof typeof LedgerDispatchPlatformStatus];

const DISPATCH_PLATFORM_STATUS_LABELS: Record<string, string> = {
  [LedgerDispatchPlatformStatus.PENDING]: '待直连',
  [LedgerDispatchPlatformStatus.PROCESSING]: '直连中',
  [LedgerDispatchPlatformStatus.INIT]: '初始化完成',
  [LedgerDispatchPlatformStatus.SAVE_AND_BIND]: '保存绑定完成',
  [LedgerDispatchPlatformStatus.FLOW_ONCE]: '转交审核完成',
  [LedgerDispatchPlatformStatus.SUCCESS]: '直连成功',
  [LedgerDispatchPlatformStatus.FAILED]: '直连失败',
};

/** 发送咕咕平台状态下拉选项（搜索/高级查询） */
export const LedgerDispatchPlatformStatusOptions = Object.values(
  LedgerDispatchPlatformStatus,
).map((value) => ({
  value,
  label: DISPATCH_PLATFORM_STATUS_LABELS[value],
}));

/** ProTable valueEnum 格式 */
export const LedgerDispatchPlatformStatusValueEnum = Object.fromEntries(
  LedgerDispatchPlatformStatusOptions.map(({ value, label }) => [
    value,
    { text: label },
  ]),
) as Record<LedgerDispatchPlatformStatusValue, { text: string }>;

// 空状态或未知状态按未开始处理
export const normalizeDispatchPlatformStatus = (
  status?: string | null,
): LedgerDispatchPlatformStatusValue | undefined => {
  if (!status) {
    return undefined;
  }
  const validStatuses = Object.values(LedgerDispatchPlatformStatus);
  return validStatuses.includes(status as LedgerDispatchPlatformStatusValue)
    ? (status as LedgerDispatchPlatformStatusValue)
    : undefined;
};

export const isDispatchPlatformFinished = (status?: string | null): boolean => {
  const normalized = normalizeDispatchPlatformStatus(status);
  return (
    normalized === LedgerDispatchPlatformStatus.SUCCESS ||
    normalized === LedgerDispatchPlatformStatus.FAILED
  );
};

export const isDispatchPlatformPending = (status?: string | null): boolean => {
  return (
    !status ||
    status.trim() === '' ||
    status === LedgerDispatchPlatformStatus.PENDING
  );
};

/** 发送咕咕平台状态展示：状态文案 + 可选失败原因 */
export const formatDispatchPlatformStatusDisplay = (
  status?: string | null,
  failureReason?: string | null,
): string => {
  if (!status || status.trim() === '') {
    return DISPATCH_PLATFORM_STATUS_LABELS[
      LedgerDispatchPlatformStatus.PENDING
    ];
  }

  const label = DISPATCH_PLATFORM_STATUS_LABELS[status];
  if (label) {
    // if (status === LedgerDispatchPlatformStatus.FAILED && failureReason?.trim()) {
    //   return `${label}：${failureReason.trim()}`;
    // }
    return label;
  }

  // if (failureReason?.trim()) {
  //   return `直连失败：${failureReason.trim()}`;
  // }

  return `直连失败，失败原因：${status}`;
};

export { API_HOST };
